// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LocaleSelector_wrapper__qt4Df","button":"LocaleSelector_button__1fKtf"};